import "./styles.scss";

import { createApp, h } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import RoomBookingCalendar from "./RoomBookingCalendar.vue";
import BookingActionsProvider from "../providers/BookingActionsProvider.vue";
import { createBootstrap } from "bootstrap-vue-next";
import { roomBookingQueryClient, initUrlConfig } from "../api";
import VueMultiselect from 'vue-multiselect';

$(document).ready(function () {
	// Check if we're on the admin frontend page
	if (!/\/room-booking\/calendar\/\d+$/.test(window.location.pathname)) {
		return;
	}

	const container = $("#vue-container");
	if (!container.length) {
		console.error("Room booking calendar container not found");
		return;
	}

	// Admin frontend configuration
	const config = {
		roomId: parseInt(container.data("roomId")),
		roomName: container.data("roomName"),
		roomBookingApiUrl: container.data("roomBookingApiUrl"),
		userApiUrl: container.data("userApiUrl"),
		dashboardUrl: container.data("dashboardUrl"),
	};

	// Validate required data
	if (
		!config.roomId ||
		!config.roomBookingApiUrl ||
		!config.userApiUrl ||
		!config.dashboardUrl
	) {
		console.error("Missing required configuration for admin frontend");
		return;
	}

	// Initialize URL configuration FIRST
	initUrlConfig({
		userApiUrl: config.userApiUrl,
		roomBookingApiUrl: config.roomBookingApiUrl,
	});

	// Wrap RoomBookingCalendar with BookingActionsProvider using render function
	const app = createApp(
		{
			render() {
				return h(BookingActionsProvider, null, {
					default: () =>
						h(RoomBookingCalendar, {
							roomId: this.roomId,
							roomName: this.roomName,
							roomBookingApiUrl: this.roomBookingApiUrl,
							userApiUrl: this.userApiUrl,
							dashboardUrl: this.dashboardUrl,
						}),
				});
			},
			props: [
				"roomId",
				"roomName",
				"roomBookingApiUrl",
				"userApiUrl",
				"dashboardUrl",
			],
		},
		config
	);

	// Setup TanStack Query
	app.use(VueQueryPlugin, {
		queryClient: roomBookingQueryClient,
	});

	// Setup Bootstrap
	app.use(createBootstrap());

	// Register vue-multiselect component
	app.component('VMultiselect', VueMultiselect);

	// Mount the app
	app.mount(container[0]);
});
